//*Libraries imports
import { Check, Minus, X, Circle } from "lucide-react";

type ActivityStatsProps = {
  completed: number;
  pending: number;
  overdue: number;
  notStarted: number;
};

export function ActivityStats(props: ActivityStatsProps) {
  return (
    <div className="flex items-center gap-6 text-sm text-gray-600">
      <div className="flex items-center gap-2" title="Concluídas">
        <div className="bg-green-100 p-1 rounded">
          <Check className="size-4 text-green-600" />
        </div>
        <span>{String(props.completed).padStart(2, "0")}</span>
      </div>
      <div className="flex items-center gap-2" title="Pendentes">
        <div className="bg-orange-100 p-1 rounded">
          <Minus className="size-4 text-orange-600" />
        </div>
        <span>{String(props.pending).padStart(2, "0")}</span>
      </div>
      <div className="flex items-center gap-2" title="Atrasadas">
        <div className="bg-red-100 p-1 rounded">
          <X className="size-4 text-red-600" />
        </div>
        <span>{String(props.overdue).padStart(2, "0")}</span>
      </div>
      <div className="flex items-center gap-2" title="Ausentes">
        <div className="bg-blue-100 p-1 rounded">
          <Circle className="size-4 text-blue-600" />
        </div>
        <span>{String(props.notStarted).padStart(2, "0")}</span>
      </div>
    </div>
  );
}
